import * as React from 'react';
import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

type Props = Readonly<{
  children: React.ReactNode;
  disabled: boolean;
}>;

export default function AuthSubmitButton({ children, disabled }: Props) {
  return (
    <html.button style={styles.button} type="submit" disabled={disabled}>
      {children}
    </html.button>
  );
}

const styles = css.create({
  button: {
    borderWidth: 0,
    paddingBlock: 10,
    paddingInline: 16,
    fontSize: 16,
    fontFamily: 'Inter, sans-serif',
    lineHeight: 1.5,
    textAlign: 'center',
    // Auth screens use a distinct brand blue; there is no design-system token.
    backgroundColor: {
      default: '#0078ff',
      ':hover': '#0067db',
    },
    color: color.neutral0,
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: 5,
    cursor: 'pointer',
  },
});
